import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import Logo from './Logo';
import ProfilePicture from './ProfilePicture';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <Link to="/profile" className="brand-link">
            {/* <Logo height={24} /> */}
            <Logo src="/logo-rastro-mais.png" height={32} />
          </Link>
        </div>

        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <div className="navbar-nav">
            <Link 
              to="/profile" 
              className={`nav-link ${isActive('/profile') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              <i className="fas fa-user"></i> Perfil
            </Link>
            <Link 
              to="/subscription" 
              className={`nav-link ${isActive('/subscription') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              <i className="fas fa-credit-card"></i> Minha Assinatura
            </Link>
            <Link 
              to="/subscription-plans" 
              className={`nav-link ${isActive('/subscription-plans') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              <i className="fas fa-list"></i> Planos
            </Link>
          </div>

          <div className="navbar-actions">
            <div className="user-info">
              <ProfilePicture 
                src={auth.currentUser?.photoURL}
                alt={auth.currentUser?.displayName || 'User'}
                size="small"
              />
              <span className="user-email">
                {auth.currentUser?.email}
              </span>
            </div>
            <button 
              onClick={handleLogout}
              className="logout-btn"
            >
              <i className="fas fa-sign-out-alt"></i> Sair
            </button>
          </div>
        </div>

        <button 
          className="navbar-toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Alternar navegação"
        >
          <span className="toggle-icon">
            <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;